import { generateVentesEntityReference } from './ventesListPageUtils';

const RESERVATION_API = '/inventaire/reservations';

/** Create stock reservations for a new sales order when inventory reservations are enabled. */
export async function createStockReservationsForSalesOrder(api, inventoryConfig, order) {
  if (!inventoryConfig?.enableReservations) return;
  const items = order?.items;
  if (!Array.isArray(items) || items.length === 0) return;

  const orderRef = order.order_number || '';
  const reservedUntil = order.expected_delivery_date || null;

  await Promise.all(items.map(async (item) => {
    if (!item.product_id && !item.product_name) return;
    try {
      await api.post(RESERVATION_API, {
        product_id: item.product_id || null,
        product_name: item.product_name || null,
        qty: parseFloat(item.quantity) || 0,
        reserved_for: orderRef || 'sales-order',
        reserved_until: reservedUntil,
        status: 'active',
        notes: orderRef ? `أمر بيع ${orderRef}` : null,
      });
    } catch (err) {
      console.warn('Stock reservation skipped for line item:', err);
    }
  }));
}

/** Auto-create a commission row when a sale is recorded (ventesConfig.autoCalculateOnSale). */
export async function createCommissionForSale(api, settings, ventesConfig, sale, existingCommissions = []) {
  if (!ventesConfig?.enableCommissions || !ventesConfig?.autoCalculateOnSale) return;

  const rate = parseFloat(ventesConfig.defaultCommissionRate);
  if (!Number.isFinite(rate) || rate <= 0) return;

  const saleAmount = parseFloat(sale.total_amount) || 0;
  if (saleAmount <= 0) return;

  const commissionAmount = Math.round((saleAmount * rate / 100) * 100) / 100;
  const commissionReference = generateVentesEntityReference(settings, 'commission', existingCommissions);
  const today = new Date().toISOString().split('T')[0];
  const status = ventesConfig.requireApprovalBeforePayment ? 'pending' : 'approved';

  try {
    await api.post('/ventes/commissions', {
      commission_reference: commissionReference,
      salesperson_name: sale.created_by || sale.customer_name || '—',
      sale_reference: sale.sale_number || '',
      sale_amount: saleAmount,
      commission_rate: rate,
      commission_amount: commissionAmount,
      commission_date: today,
      status,
      notes: sale.sale_number ? `عمولة تلقائية — ${sale.sale_number}` : null,
    });
  } catch (err) {
    console.warn('Auto commission creation failed:', err);
  }
}
